import { ITableProps } from "../../types/table"
import { ISystemBranch, IUserCreate, IUserPassword, IUserUpdateData } from "../../types/user";
import { api } from "../api"

const UsersService = async (name: string, table: ITableProps) => {

    const response = await api.get('users', {
        params: {
            name,
            pageNumber: table.page,
            direction: table.direction,
            sortBy: table.sortBy,
            pageSize: table.pageSize
        }
    });

    return response;

}

const AllUsersService = async () => {

    const response = await api.get('users/all');

    return response;

}

const CreateUserService = async (data: IUserCreate) => {

    const response = await api.post('users', data);

    return response;

}

const GetUserByIdService = async (id: number) => {

    const response = await api.get(`users/${id}`);

    return response;

}


const UpdateUserService = async (id: number, data: IUserUpdateData) => {

    const response = await api.put(`users/${id}`, data);

    return response;

}

const UpdateUserPasswordService = async (id: number, data: IUserPassword) => {
    
    const response = await api.put(`users/password/${id}`, data);
    
    return response

}

const DeleteUserService = async (id: number) => {

    const response = await api.delete(`users/${id}`);

    return response;

}

const ActiveUserService = async (id: number) => {

    const response = await api.delete(`users/active/${id}`);

    return response;

}

const UpdateUserSystemsService = async (id: number, systemsId: ISystemBranch[]) => {

    const response = await api.put(`users/systems/${id}`, {
        userSystems: systemsId
    });

    return response;

}

export {
    UsersService,
    AllUsersService,
    CreateUserService,
    GetUserByIdService,
    UpdateUserService,
    UpdateUserPasswordService,
    DeleteUserService,
    ActiveUserService,
    UpdateUserSystemsService
}